<template>
   
    <Column fit class="mainmenu" padding="0 14px" v-if="db.profile.id">
        
        <br>
        <div class="column center pointer click" style="width: 100%;">
            <router-link :to="{name: 'home'}">
                <svg width="45" height="51" viewBox="0 0 45 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.6772 21.3092L22.3313 25.4981L0 12.7657V12.7567L22.3644 0.000366211L44.6983 12.7435L33.0458 19.3882L23.2066 13.7737C22.8209 13.5752 22.3725 13.5313 21.9549 13.6513C21.5372 13.7713 21.1826 14.0459 20.9649 14.4178C20.7472 14.7897 20.6833 15.2302 20.7864 15.6475C20.8896 16.0648 21.1518 16.4267 21.5185 16.6577L29.6772 21.3092Z" fill="var(--special)" fill-opacity="1"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.3314 50.9809L22.3646 50.9998L44.7217 38.2398V29.8857L29.6681 21.3034L22.3314 25.4868V33.8398L23.2068 34.3388C23.5735 34.5699 23.8358 34.9317 23.9389 35.3491C24.042 35.7664 23.9781 36.2069 23.7604 36.5788C23.5427 36.9507 23.1881 37.2252 22.7705 37.3452C22.6265 37.3866 22.4789 37.4085 22.3314 37.4113V50.9809ZM44.6897 12.738L33.0369 19.3825L44.7217 26.0501V12.7562L44.6897 12.738Z" fill="var(--special)" fill-opacity="1"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 38.2471L22.3644 50.9998L22.3754 50.9935V37.4098C22.0804 37.4231 21.7845 37.3597 21.5185 37.2228L0 24.9532V38.2471ZM22.3754 33.865L0 21.1103V12.7562L0.0245127 12.7422L22.3754 25.4868V33.865Z" fill="var(--special)" fill-opacity="1"/></svg>
            </router-link>
            <p class="mini">ID: {{ db.profile.id }}</p>
            <p>{{ db.profile.name }}</p>
            <p class="mini">{{ db.profile.title }}</p>            
            <p class="mini">{{ db.profile.email }}</p>            
            <p class="mini" v-if="db.god" style="color: var(--primary);">God</p>            
        </div>

        <ChatStatus/>


        <hr>

        

        <!-- menu -->
        <router-link class="menuitem" :class="{active: current == item.id || isActive}" v-for="(item, index) in menuitems" :key="index" :to="{name: item.name}">{{tools.title(item.id)}} <span v-if="item.count">{{ tools.fm(item.count,',') }}</span></router-link>
        <hr>
        
        <div class="row">
            <Switch v-model="viewByMacro">Macro</Switch>            
        </div>
        <br>

        <div class="column" v-if="viewByMacro">
            <p class="menuitem link" @click="showAddType = true">+create category</p>
            <br>
            <div class="column" v-for="(item, index) in groupRoots" :key="index">
                <p class="menuitem" style="opacity: .7;">{{ item.id }} <sup v-if="roots.macroRootsAssetsCount(item.id) > 0" style="color: var(--good); font-size: 8px;">{{ roots.macroRootsAssetsCount(item.id) }}</sup> </p>
                <router-link class="menuitem" :class="{on: root.active, off: !root.active}" v-for="(root, index) in item.list" :key="index" :to="`/category/${root.sid}/home`">{{cut(root.title)}} <sup style="color: var(--good); font-size: 8px;">{{ root.count }}</sup> </router-link>            
            </div>
            <br>
        </div>

        <div v-else>
            <div class="column">
                <router-link class="menuitem on" :class="{active: $route.path.startsWith(`/category/${item.sid}`)}" v-for="(item, index) in roots.active" :key="index" :to="`/category/${item.sid}/home`">{{cut(item.title)}} <sup style="color: var(--good); font-size: 8px;">{{ item.count }}</sup> </router-link>
                <hr>            
                <router-link class="menuitem off" v-for="(item, index) in roots.inactive" :key="index" :to="{name: 'category/settings', params:{category: item.sid}}">{{cut(item.title)}} <sup style="color: var(--good); font-size: 8px;">{{ item.count }}</sup> </router-link>
                <p  class="menuitem link" @click="showAddType = true">+create</p>
            </div>
            <br>
        </div>
        
        
        

        
        
        <div style="height: 100%;"></div>   
        
        <router-link class="menuitem" to="/developers">Developers</router-link> 
        <router-link class="menuitem" to="/profile">Profile</router-link> 
        <!-- <p class="menuitem" @click="reindexStats()">Reindex stats</p> -->
        <hr>
        <p class="menuitem pointer click" @click="db.logout()">Logout</p>                 
        <br>
    </Column>

    <div v-if="db.profile.id" style="z-index: 1000; opacity: .3; position: fixed; bottom: 20px; right: 20px;">
        <div class="row ch">
            <Color class="mr4 hover" width="16px" height="16px" @update="changePrimaryColor" v-model="dict.color"/>
            <!-- <div class="click pointer column mr4" @click="resetBackendCache()" title="Hard reset backend cache"><svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#575757"/><path d="M5.37784 10.556L4.81585 11.053C4.8828 11.1285 4.96431 11.1897 5.05549 11.233C5.14667 11.2763 5.24564 11.3007 5.34648 11.3048C5.44732 11.3089 5.54795 11.2926 5.64235 11.2569C5.73675 11.2212 5.82297 11.1668 5.89584 11.097L5.37784 10.556ZM7.51884 9.54101C7.6558 9.40191 7.73312 9.21489 7.73438 9.01969C7.73565 8.82448 7.66076 8.63648 7.52562 8.49561C7.39048 8.35475 7.20575 8.27212 7.01066 8.26528C6.81557 8.25845 6.62551 8.32795 6.48084 8.45901L7.51884 9.54101ZM4.56085 8.50301C4.49682 8.42512 4.41775 8.36093 4.32836 8.31429C4.23897 8.26766 4.14109 8.23952 4.04057 8.23157C3.94006 8.22362 3.83898 8.23602 3.74336 8.26803C3.64775 8.30004 3.55958 8.35099 3.4841 8.41785C3.40863 8.48472 3.34742 8.56611 3.30412 8.65716C3.26082 8.74822 3.23633 8.84707 3.2321 8.94781C3.22788 9.04855 3.24401 9.14911 3.27953 9.24347C3.31505 9.33783 3.36924 9.42406 3.43885 9.49701L4.56085 8.50301ZM12.9308 7.00901C12.9977 7.08137 13.0781 7.13985 13.1676 7.18112C13.257 7.22239 13.3537 7.24564 13.4521 7.24954C13.5506 7.25344 13.6488 7.23792 13.7412 7.20385C13.8337 7.16979 13.9185 7.11785 13.9908 7.05101C14.0632 6.98417 14.1217 6.90373 14.163 6.81428C14.2042 6.72484 14.2275 6.62814 14.2314 6.52971C14.2353 6.43128 14.2197 6.33304 14.1857 6.24061C14.1516 6.14818 14.0997 6.06337 14.0328 5.99101L12.9308 7.00901ZM10.0448 4.25001C7.05884 4.25001 4.62885 6.65301 4.62885 9.63001H6.12884C6.12884 7.49301 7.87584 5.75001 10.0448 5.75001V4.25001ZM4.62885 9.63001V10.556H6.12884V9.63001H4.62885ZM5.89784 11.097L7.51984 9.54101L6.48184 8.45901L4.85985 10.014L5.89784 11.097ZM5.93984 10.058L4.56085 8.50301L3.43885 9.49701L4.81585 11.053L5.93984 10.058ZM14.0328 5.99101C13.5242 5.44078 12.9081 5.00198 12.2213 4.70232C11.5346 4.40265 10.7931 4.24864 10.0438 4.25001V5.75001C10.5864 5.74868 11.1233 5.85998 11.6206 6.07686C12.1178 6.29375 12.5647 6.6115 12.9328 7.01001L14.0328 5.99101ZM14.6188 9.44401L15.1788 8.94601C15.1118 8.87056 15.0302 8.80942 14.939 8.76624C14.8478 8.72307 14.7488 8.69874 14.648 8.69473C14.5472 8.69071 14.4465 8.70709 14.3522 8.74288C14.2578 8.77867 14.1717 8.83313 14.0988 8.90301L14.6188 9.44401ZM12.4798 10.458C12.3364 10.5959 12.2535 10.7852 12.2496 10.9842C12.2457 11.1831 12.3209 11.3755 12.4588 11.519C12.5968 11.6625 12.786 11.7453 12.985 11.7492C13.184 11.7532 13.3764 11.6779 13.5198 11.54L12.4798 10.458ZM15.4398 11.498C15.5736 11.6405 15.7578 11.7251 15.953 11.7339C16.1483 11.7426 16.3393 11.6748 16.4853 11.5448C16.6312 11.4148 16.7207 11.233 16.7347 11.0381C16.7486 10.8431 16.6859 10.6504 16.5598 10.501L15.4398 11.498ZM7.04684 13.005C6.90998 12.8633 6.72286 12.7812 6.52592 12.7763C6.32898 12.7714 6.13804 12.8442 5.99434 12.979C5.85065 13.1138 5.76575 13.2997 5.75798 13.4965C5.75022 13.6933 5.82021 13.8853 5.95284 14.031L7.04684 13.005ZM9.93484 15.75C12.9278 15.75 15.3688 13.35 15.3688 10.37H13.8688C13.8688 12.505 12.1158 14.25 9.93484 14.25V15.75ZM15.3688 10.37V9.44401H13.8688V10.37H15.3688ZM14.0988 8.90301L12.4798 10.458L13.5198 11.54L15.1378 9.98501L14.0988 8.90301ZM14.0588 9.94301L15.4388 11.497L16.5608 10.501L15.1788 8.94601L14.0588 9.94301ZM5.95184 14.03C6.46247 14.574 7.07939 15.0072 7.76437 15.3029C8.44935 15.5986 9.18777 15.7505 9.93384 15.749V14.249C8.79084 14.249 7.76384 13.769 7.04584 13.004L5.95184 14.03Z" fill="#C0C0C0"/></svg></div> -->
            <!-- <div class="column pointer click" @click="support = true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66723 8.3314C6.66723 8.11038 6.75503 7.89842 6.91131 7.74214C7.06759 7.58586 7.27955 7.49807 7.50057 7.49807H12.5006C12.7216 7.49807 12.9335 7.58586 13.0898 7.74214C13.2461 7.89842 13.3339 8.11038 13.3339 8.3314C13.3339 8.55241 13.2461 8.76437 13.0898 8.92065C12.9335 9.07693 12.7216 9.16473 12.5006 9.16473H7.50057C7.27955 9.16473 7.06759 9.07693 6.91131 8.92065C6.75503 8.76437 6.66723 8.55241 6.66723 8.3314ZM7.50057 10.8314C7.27955 10.8314 7.06759 10.9192 6.91131 11.0755C6.75503 11.2318 6.66723 11.4437 6.66723 11.6647C6.66723 11.8857 6.75503 12.0977 6.91131 12.254C7.06759 12.4103 7.27955 12.4981 7.50057 12.4981H10.8339C11.0549 12.4981 11.2669 12.4103 11.4231 12.254C11.5794 12.0977 11.6672 11.8857 11.6672 11.6647C11.6672 11.4437 11.5794 11.2318 11.4231 11.0755C11.2669 10.9192 11.0549 10.8314 10.8339 10.8314H7.50057ZM0.000575442 9.99806C0.0010007 7.79648 0.72795 5.65656 2.06865 3.91028C3.40936 2.164 5.28887 0.908968 7.41563 0.339872C9.54239 -0.229223 11.7975 -0.0805683 13.8312 0.762775C15.8648 1.60612 17.5633 3.09701 18.6632 5.00417C19.7631 6.91133 20.2028 9.12815 19.9143 11.3107C19.6257 13.4933 18.6249 15.5197 17.0672 17.0755C15.5095 18.6313 13.4819 19.6295 11.2989 19.9153C9.11595 20.2012 6.89968 19.7586 4.9939 18.6564L1.09724 19.9564C0.953278 20.0045 0.798922 20.0123 0.650832 19.9791C0.502742 19.9458 0.366541 19.8728 0.256929 19.7678C0.147317 19.6628 0.0684578 19.5299 0.0288606 19.3834C-0.0107366 19.2368 -0.00956737 19.0823 0.0322422 18.9364L1.21891 14.7847C0.417269 13.3168 -0.00172981 11.6706 0.000575442 9.99806ZM10.0006 1.66474C8.5292 1.66464 7.08404 2.05412 5.81199 2.79358C4.53994 3.53304 3.48635 4.59611 2.75832 5.87473C2.03029 7.15336 1.65378 8.60195 1.66705 10.0733C1.68033 11.5446 2.08292 12.9861 2.8339 14.2514C2.89168 14.3491 2.92888 14.4577 2.94321 14.5703C2.95754 14.6829 2.9487 14.7973 2.91724 14.9064L2.06891 17.8731L4.83224 16.9531C4.94959 16.9139 5.0742 16.9014 5.19701 16.9163C5.31981 16.9313 5.43774 16.9735 5.54223 17.0397C6.63435 17.7309 7.87226 18.1585 9.15811 18.2889C10.444 18.4193 11.7425 18.2487 12.9511 17.7908C14.1597 17.3329 15.2453 16.6001 16.1219 15.6505C16.9986 14.7008 17.6423 13.5602 18.0022 12.3189C18.3622 11.0776 18.4285 9.76957 18.1959 8.49823C17.9632 7.22689 17.4381 6.02708 16.6619 4.99364C15.8858 3.9602 14.8799 3.12146 13.7238 2.54371C12.5677 1.96596 11.293 1.66504 10.0006 1.66474Z" fill="var(--g4)"/></svg>
            </div>   -->          

        </div>
    </div>

    

    <!-- create attr -->
    <Popup v-model="showAddType">
        <template #icon><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M45 17.5L41.475 13.975L25.625 29.825L29.15 33.35L45 17.5ZM55.6 13.975L29.15 40.425L18.7 30L15.175 33.525L29.15 47.5L59.15 17.5L55.6 13.975ZM1.025 33.525L15 47.5L18.525 43.975L4.575 30L1.025 33.525Z" fill="var(--special)"/></svg></template>            
        <template #title>Add asset type</template>      
        <template #line>Write list each on new line</template>    
        <div class="column w600">
            <textarea ref="list" class="w600" style="height: 300px;" :placeholder="`Watches\nYachts\nArt\netc...`"></textarea>
            <br>
            <div class="row center">                
            <p class="tag" @click="roots.create($refs.list.value);showAddType = false;">Add</p>
            </div>
        </div>            
    </Popup>

    <!-- create attr -->
    <Popup v-model="support">
            <template #icon><svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28 52.5C43.463 52.5 56 41.531 56 28C56 14.469 43.463 3.5 28 3.5C12.537 3.5 0 14.469 0 28C0 34.16 2.6005 39.795 6.895 44.1C6.5555 47.656 5.4355 51.555 4.1965 54.481C3.92 55.132 4.4555 55.86 5.152 55.748C13.048 54.453 17.7415 52.465 19.782 51.429C22.4622 52.1464 25.2255 52.5065 28 52.5Z" fill="var(--primary)"/></svg></template>            
            <template #title>Support</template>      
            <template #line>Describe bug or suggestion.</template>    
            <div class="column w600">
              <textarea ref="supportMessage" class="w600" style="height: 300px;" placeholder="Describe bug/suggestion..."></textarea>
              <br>
              <div class="row center">                
                <p class="tag" @click="api.support($route, $refs.supportMessage.value, console.logs);support=false">Send</p>
              </div>
            </div>            
        </Popup>



</template>
<script setup>
</script>
<script>
import { useTitle } from '@vueuse/core';
export default {
    data: function () {return {        
        showAddType: false,
        support: false,       
        viewByMacro: false, 
    }},
    mounted() {
        
        // get roots
        this.roots.refresh()

        if (this.db.profile.id) {
            // this.db.updateStats()
            this.dict.refresh()
            const title = useTitle()            
            title.value = 'Stima Team' // change current title
        }
        if (this.dict.color){
            setTimeout(() => {
                let r = document.querySelector('body.dark');
                if (r != null) r.style.setProperty('--primary', this.dict.color);                
            }, 0);
            
        }
        
    },
    methods: {
        cut(text, max = 15) {
            return text.length > max ? text.slice(0, max) + '…' : text;
        },
        changePrimaryColor(newColor){
            // console.log('new color', newColor)
            let r = document.querySelector('body.dark');
            r.style.setProperty('--primary', newColor);
        },

        resetBackendCache(){
            let res = this.api.send('admin/dict/reset',{})
            if (res.error){
                console.error(res.error)
            }
        },
        
        reindexStats(){
            
            //stats
	// case "stats/assets/summary":
	// case "stats/assets/locations":
	
            let res = this.api.send('stats/assets/summary',{})
            if (res.error){
                console.error(res.error)
                return
            }
            console.log("======================== Stats ============================")
            console.log(res.resp)
            
            let res2 = this.api.send('stats/assets/locations',{})
            if (res2.error){
                console.error(res2.error)
                return
            }
            console.log("======================== Stats ============================")
            console.log(res2.resp)
        },

    },
    computed: {
        menuitems(){
            // by access
            let menu = [
                { id: 'home', name:'home'},
            ]
            
            let has = this.db.access || this.db.god
            if (has('accessNews')) menu.push({ id: 'news', name:'news'})
            if (has('accessAccounts')) menu.push({ id: 'users', name:'accounts'})
            if (has('accessAssets')) menu.push({ id: 'assets', name:'assets'})
            if (has('roleGod')) menu.push({ id: 'team', name:'team'})
            if (has('accessDocs')) menu.push({ id: 'docs', name:'docs'})
            if (has('accessSupport')) menu.push({ id: 'support', name:'support'})
            // if (has('certify')) menu.push({ id: 'certify', name:'certify'})
            // if (has('cert')) menu.push({ id: 'cert', name:'cert'})
            // if (has('tasks')) menu.push({ id: 'tasks', name:'tasks'})
            
            // menu.push({ id: 'developers', name:'developers'})
            return menu
        },
        access(){
            if (this.db.profile.god) return this.dept
            let list = []
            this.dept.forEach(item => {
                 if (this.db.menu[item]) list.push(item)   
            });
            return list
        },
        groupRoots(){
            let roots = this.roots
            let list = {}
            this.roots.macrocategory.forEach(macro => {
                list[macro] = roots.macroRoots(macro)
            });
            list['Other'] = roots.macroRootless

            var res = []
            for (var k in list){
                let v = list[k]
                res.push({id: k, list: v})
            }
            res = res.sort((a, b) => a.id.localeCompare(b.id))
            return res
        },
       
    },   
}
</script>


<style scoped>
.mainmenu{
    background: var(--g03);
    margin: 0;
    padding: 0;
}
.truncate {
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

